import {
  SET_GROUP_AVAILABLE_SERVICES,
  SET_GROUP_SELECTED_SERVICES,
  SET_ORDER_DETAILS,
  SET_GROUP_DATA,
} from '../ActionsTypes';

const initialState = {
  availableServices: null,
  selectedServices: [],
  orderDetails: null,
  groupData: null,
};
export const GroupReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_GROUP_AVAILABLE_SERVICES:
      return { ...state, availableServices: payload };
    case SET_GROUP_SELECTED_SERVICES:
      return { ...state, selectedServices: payload };
    case SET_ORDER_DETAILS:
      return { ...state, orderDetails: payload };
    case SET_GROUP_DATA:
      return { ...state, groupData: payload };
    default:
      return state;
  }
};
